import React, { useState } from 'react'

import { CalendarFormInput } from '@/modules/online-mass-messages/ui/time-calendar/calendar-input.tsx'
import { ToggleSection } from '@/modules/tasks/components/create-task-dialog/toggle-section.tsx'

function convertToDate(value: string) {
  try {
    return new Date(value)
  } catch (error) {
    throw new Error(`tried to convert invalid date: ${value}`)
  }
}

function convertFromDate(date: Date) {
  const year = date.getFullYear()
  const month = (date.getMonth() + 1).toString().padStart(2, '0')
  const day = date.getDate().toString().padStart(2, '0')
  const hours = date.getHours().toString().padStart(2, '0')
  const minutes = date.getMinutes().toString().padStart(2, '0')
  const seconds = date.getSeconds().toString().padStart(2, '0')

  return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`
}

export const DueDateSelector = () => {
  const [active, setActive] = useState(true)

  return (
    <div className="flex flex-col gap-2">
      <ToggleSection
        label="Due Date"
        labelFor="assignees"
        className="w-full justify-between"
        enabled={active}
        onToggle={() => {
          setActive(!active)
        }}
      >
        <CalendarFormInput
          name="dueDate"
          convertToDate={convertToDate}
          convertFromDate={convertFromDate}
          defaultDate={
            // Tomorrow
            new Date(Date.now() + 24 * 60 * 60 * 1000)
          }
        />
      </ToggleSection>
    </div>
  )
}
